<template>
    <div>
        <bottom-dialog v-model="showDialog" :dialog="!$vuetify.breakpoint.mobile" scrollable>
            <v-card flat tile>
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('CHECKIN')}}
                    <v-spacer />
                    <v-btn icon @click="showDialog = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text v-if="$store.state.isLoggedIn" class="text-center mt-4">
                    <div v-if="doors.length">
                        <div v-for="door in doors" :key="door.id" class="mb-6">
                            <v-badge color="red" overlap content="1 klipp" :value="!!door.punch" class="fill-width" offset-x="40">
                                <v-btn class="zoezi-button-thin" :color="door.buttonColor" block @click="doorClick(door)" :loading="door.opening" :class="door.buttonClass" :disabled="!inRangeOf(door)">
                                    <v-icon left v-if="door.require_qrcode">mdi-qrcode-scan</v-icon>
                                    <v-icon left v-if="door.position">mdi-map-marker</v-icon>
                                    {{door.name}}
                                </v-btn>
                                <div v-if="door.position">
                                    <div v-if="!position" class="red--text">{{$translate("You do not have positioning enabled. Activate it to be able to open this door.")}}</div>
                                    <div v-else-if="position && !inRangeOf(door)" class="red--text">{{$translate("You are too far away from this door. Move closer to be able to open it.")}}</div>
                                </div>
                            </v-badge>
                        </div>
                    </div>
                    <div v-else>
                        {{$translate('Right now there are no doors you can open')}}
                    </div>
                    <div v-if="showQrScannerBtn">
                        <div >{{$translate("Are you standing by a QR-code?")}}</div>
                        <v-btn  class="zoezi-button-thin" :color="scannerDoor.buttonColor" block @click="qrDoor = scannerDoor; showQrScanner = true" :class="scannerDoor.buttonClass" :loading="scannerDoor.opening">
                            <v-icon left>{{scannerDoor.icon}}</v-icon>
                            {{$translate(scannerDoor.text)}}
                        </v-btn>
                    </div>
                </v-card-text>
                <v-card-text v-else class="text-center mt-4">
                    <div >{{$translate("You need to log in to be able to check in")}}</div>
                    <v-btn  class="zoezi-button-thin" color="primary" block to="/login" @click="showDialog = false">
                        {{$translate("Log in")}}
                    </v-btn>
                </v-card-text>
            </v-card>
        </bottom-dialog>

        <!-- QR-Scanner -->
        <bottom-dialog v-model="showQrScanner" :dialog="!$vuetify.breakpoint.mobile" v-if="showQrScanner">
            <v-card flat tile>
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{ $translate("Scan QR-code") }}
                    <v-spacer />
                    <v-btn icon @click="showQrScanner = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <div v-if="!qrDoor || !qrDoor.loading">
                    <div v-if="canCheckinOthers" style="width: 95%; margin: 0 auto;">
                        <p class="text-center my-1 subtitle-1">{{ $translate("Select who you want to check in with the QR code") }}</p>
                        <div>
                            <v-chip
                                class="ma-1" v-for="user in canBookFor" :key="user.id" @click="selectUser(user)"
                                :color="user.blocks && user.blocks.find(b => b.block_entry) ? 'error' : usersToCheckIn.find(u => u.id == user.id) ? 'success' : ''"
                            >
                                {{user.name}}
                            </v-chip>
                        </div>
                    </div>
                    <qr-scanner class="pa-2" auto-start @scan="qrCodeScanned" />
                </div>
                <div v-else class="d-flex align-center justify-center text-center px-4 py-8">
                    <v-progress-circular v-if="qrDoor.opening" color="primary" indeterminate size="32"></v-progress-circular>
                    <v-icon v-else :color="qrDoor.buttonColor" class="text-h3 my-auto">{{ qrDoor.success ? "mdi-checkbox-marked-circle": "mdi-alert-circle" }}</v-icon>
                    <span v-if="!qrDoor.opening" class="text-h4 ml-2">{{ $translate(qrDoor.reason) }}</span>
                </div>
            </v-card>
        </bottom-dialog>

        <!-- Multiple checkin dialog -->
        <v-dialog
            v-model="multipleCheckin"
            width="500" >
            <v-card>
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('Checking in')}}:
                </v-card-title>
                <v-card-text class="mt-4">
                    <div class="mt-2" v-for="user in usersToCheckIn" :key="user.id">
                        <v-row no-gutters>
                            <zoezi-user-avatar :user="user" :size="32" />
                            <span style="margin: auto 0 auto 8px">{{ user.name }}</span>
                            <v-spacer />
                            <v-icon v-if="user.success === true" color="success" size="32">mdi-checkbox-marked-circle</v-icon>
                            <v-tooltip top v-else-if="user.success === false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="red"
                                        size="32"
                                        v-bind="attrs"
                                        v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </template>
                                <span>{{ $translate(user.reason) }}</span>
                            </v-tooltip>
                            <v-progress-circular v-else color="primary" indeterminate size="32"></v-progress-circular>
                        </v-row>
                    </div>

                </v-card-text>
                <v-card-actions>
                    <v-btn
                        block
                        color="primary"
                        :loading="!allCheckedIn"
                        @click="closeMultipleCheckin"
                    >
                        {{ $translate(allCheckedIn ? 'Ready' : 'Loading') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {debounce} from 'lodash';
import QrScanner from '../views/QrScanner.vue';
import BottomDialog from './BottomDialog.vue';
import ZoeziUserAvatar from './UserAvatar.vue';
import {includes} from 'lodash';

export default {
    name: 'zoezi-checkin-dialog',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        onlyShowQrScanner: {
            type: Boolean,
            default: false
        },
        resources: {
            type: Array,
            default: () => []
        },
        allSites: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BottomDialog,
        QrScanner,
        ZoeziUserAvatar
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value) { // Opening dialog
                    this.updatePosition();
                    this.updateDoors();
                    this.positionWatchId = window.navigator?.geolocation?.watchPosition(this.updatePosition);
                } else { // Closing dialog
                    if (this.positionWatchId) {
                        window.navigator.geolocation.clearWatch(this.positionWatchId);
                        this.positionWatchId = null;
                    }
                }

                if (this.onlyShowQrScanner) {
                    this.showQrScanner = value;
                    this.qrDoor = null;
                } else {
                    this.showDialog = value;
                }
            }
        },
        showQrScanner(value) {
            if (!value && !this.showDialog ) {
                this.$emit('input', value);
            }
        },
        showDialog(value) {
            this.$emit('input', value);
        },
        '$store.state.now30s'() {
            if (this.value) {
                this.updatePosition();
            }
        },
        '$store.state.user': {
            immediate: true,
            handler(value) {
                this.usersToCheckIn = [];
                if(value && !value.blocks?.find(b => b.block_entry)){
                    this.usersToCheckIn.push(this.canBookFor.find((item) => item.id == value.id ));
                }
            }
        },
        '$store.state.selectedSiteId'() {
            this.updateDoors();
        },
        resources() {
            this.updateDoors();
        },
        allSites() {
            this.updateDoors();
        }
    },

    data: () => ({
        showDialog: false,
        showQrScanner: false,
        showQrScannerBtn: false,
        multipleCheckin: false,
        unsubscribe: null,
        doors: [],
        qrDoor: null,
        scannerDoor: {
            id: null,
            buttonColor: 'primary',
            buttonClass: null,
            opening: false,
            require_qrcode: true,
            position: null,
            defaultText: 'Scan QR-code',
            defaultIcon: 'mdi-qrcode-scan',
            text: null,
            icon: null
        },
        position: null, // Updates every 30s and through watchPosition event
        positionWatchId: null,
        usersToCheckIn: []
    }),
    computed: {
        canBookFor() {
            if (!this.$store.state.user) {
                return [];
            }
            return this.$store.state.user.canBookFor.map(x => ({
                id: x.id,
                name: x.id == this.$store.state.user.id ? this.$translate('Myself') : x.name,
                imagekey: x.imagekey,
                success: 'loading',
                blocks: x.blocks
            }));
        },
        canCheckinOthers() {
            if (!this.$store.state.user) {
                return false;
            }
            let others = this.canBookFor.filter((item) => (this.$store.state.user.id != item.id));
            return others.length > 0;
        },
        allCheckedIn() {
            if (!this.$store.state.user) {
                return false;
            }
            return this.usersToCheckIn.every((item) => item.success != 'loading');
        },
    },
    methods: {
        selectUser(user) {
            if (user.blocks?.find(b => b.block_entry)) {
                return;
            }
            if (this.usersToCheckIn.find(u => u.id == user.id)) {
                this.usersToCheckIn = this.usersToCheckIn.filter((u) => u != user);
            } else {
                this.usersToCheckIn.push(user);
            }
        },
        qrCodeScanned(code) {
            if (!this.qrDoor || this.qrDoor == this.scannerDoor) {
                let callback = () => {
                    if (this.showDialog) {
                        this.showQrScanner = false;
                        this.qrDoor.loading = false;
                    } else {
                        setTimeout(() => {
                            this.showQrScanner = false;
                            this.qrDoor.loading = false;
                            delete this.qrDoor['reason'];
                            delete this.qrDoor['success'];
                        }, 5000);
                    }
                }

                const onError = () => {
                    if (this.qrDoor) this.showDoorEffect(this.qrDoor, false);
                    this.$store.commit('showErrorDialog', {
                        title: this.$translate('Could not open the door')
                    });
                }

                this.$api.get('/api/door/scan', {data: code}).then(door => {
                    if (door) {
                        if (door.punch) {
                            // FIXME: Show "Klipp kommer dras". Vid incheckning kommer ett klipp dras från ditt klippkort. Checka in, 1 klipp
                            console.log('Confirm deducting punch card')
                        }

                        let existingDoor = this.doors.find(x => x.id == door.id);

                        if (!this.qrDoor) {
                            this.qrDoor = existingDoor ? existingDoor : this.scannerDoor;
                            this.qrDoor.loading = true;
                        }

                        if (existingDoor){
                            this.openDoor(this.qrDoor, code, null, callback);
                        }
                        else{
                            this.checkin(this.qrDoor, code, callback);
                        }
                    } else {
                        onError();
                    }
                }).catch(onError);
            } else {
                this.showQrScanner = false;
                this.openDoor(this.qrDoor, code, null);
            }
        },
        updatePosition(pos) {
            const update = (pos) => {
                this.position = [pos.coords.latitude, pos.coords.longitude];
            }
            if (!pos) {
                if (window.navigator) {
                    window.navigator.geolocation.getCurrentPosition(update);
                } else {
                    this.position = null;
                }
            } else {
                update(pos);
            }
        },
        inRangeOf(door) {
            if (!door.position) { return true; }
            if (!this.position) { return false; }
            const maxRange = door.max_distance_to_door / 1000;
            let [lng, lat] = door.position.split(',');
            const distance = Number.haversine(this.position[0], this.position[1], Number(lng), Number(lat));
            return distance <= maxRange;
        },
        async updateDoorsRequest() {
            this.checkQrEntry();
            if (!this.$store.state.settings?.modules?.MobileEntry) return;

            let allDoors = await this.$api.get('/api/door/get', this.allSites ? { all_sites: true } : { site_id: this.$store.state.selectedSiteId }).catch(() => []);

            allDoors.forEach(door => {
                door.opening = false;
                door.buttonColor = 'primary';
            });

            if (this.resources?.length) {
                allDoors = allDoors.filter(d => includes(this.resources, d.id));
            }

            this.doors = allDoors.sort((a, b) => a.name.localeCompare(b.name));
        },
        doorClick(door) {
            if (door.require_qrcode) {
                this.qrDoor = door;
                this.showQrScanner = true;
            } else {
                this.openDoor(door);
            }
        },
        showDoorEffect(door, success) {
            door.buttonColor = success ? 'success' : 'error';
            door.buttonClass = success ? 'animate__animated animate__flipInX' : 'animate__animated animate__shakeX';
            door.text = success ? 'Welcome' : 'GENERIC_ERROR';
            door.icon = success ? 'mdi-check-bold' : 'mdi-google-downasaur';
            if (!this.multipleCheckin) {
                setTimeout(() => {
                    this.closeDialog(door, success);
                }, 5000);
            }
        },
        closeDialog(door, success){
            door.buttonColor = 'primary';
            door.buttonClass = null;
            door.text = door.defaultText;
            door.icon = door.defaultIcon;
            this.showDialog = this.onlyShowQrScanner ? false : !success;
        },
        checkin(door, qrcode_entry_id, callback=null) {
            if (this.usersToCheckIn.filter((user) => user.id != this.$store.state.user.id ).length > 0) {
                door.opening = true;
                this.multipleCheckin = true;
                this.usersToCheckIn.forEach((user) => {
                    user.success = 'loading';
                    this.$api.post('/api/memberapi/entry/qrcode', { qrcode_entry_id, user_id: user.id }).then(response => {
                        let promise = response.json().then(entry => {
                            const success = entry?.success;
                            this.showDoorEffect(door, !!success);
                            user.success = !!success || false;
                            if (!user.reason) {
                                user.reason = entry.reason;
                            }
                            door.success = success;
                            door.reason = success ? 'Welcome' : entry.reason;
                        });
                        if (callback) {
                            promise.then(callback);
                        }
                    }).catch(() => {
                        user.success = false;
                        user.reason = 'Incheckning misslyckades';
                        this.showDoorEffect(door, false);
                    });
                });
                door.opening = false;
            } else {
                door.opening = true;
                this.$api.post('/api/memberapi/entry/qrcode', { qrcode_entry_id }).then(response => {
                    door.opening = false;
                    let promise = response.json().then(entry => {
                        const success = entry?.success;
                        this.showDoorEffect(door, !!success);
                        door.success = success;
                        door.reason = success ? 'Welcome' : entry.reason;
                    });
                    if (callback) {
                        promise.then(callback);
                    }
                });
            }
        },
        openDoor(door, qr_code, id, callback=null) {
            door.opening = true;
            const position = this.position && this.position.join(',');
            let success = false;
            if (this.usersToCheckIn.length == 0) {
                this.usersToCheckIn.push(this.canBookFor.find((item) => item.id == this.$store.state.user.id ))
            }
            this.usersToCheckIn.forEach(user => {
                this.$api.post('/api/door/open', null, {id: door.id || id, data: qr_code, position, entry_user_id: user.id}).then(response => {
                    let promise = response.json().then(responseParsed => {
                        if(!success){
                            success = response.ok && !!responseParsed;
                        }
                        if (qr_code) {
                            this.qrDoor.success = success;
                            this.qrDoor.reason = success ? 'Welcome' : (responseParsed?.message ?? 'GENERIC_ERROR');
                            this.qrDoor.opening = false;
                        } else {
                            door.opening = false;
                        }
                        this.showDoorEffect(door, success);
                        if (!success) {
                            this.$store.commit('showErrorDialog', {
                                title: this.$translate('Could not open the door')
                            });
                        }
                    });
                    if (callback) {
                        promise.then(callback);
                    }
                });
            });
        },
        checkQrEntry(){
            this.$api.get('/api/memberapi/qr_resource_available').then(qrResourceAvailable => this.showQrScannerBtn = qrResourceAvailable);
        },
        closeMultipleCheckin(){
            this.multipleCheckin = false;
            this.closeDialog(this.qrDoor, this.usersToCheckIn.every(user => user.success === true));
        },
    },
    mounted() {
        this.updateDoors = debounce(this.updateDoorsRequest, 500);
        this.scannerDoor.text = this.scannerDoor.defaultText;
        this.scannerDoor.icon = this.scannerDoor.defaultIcon;
        this.$nextTick(() => {
            this.updateDoors();
        })
        this.unsubscribe = this.$root.$api.subscribe({type: 'resourcebookingservice', callback: (__, event) => {
            if (['add', 'change'].includes(event.action)) {
                return;
            }
            if (event.data.find(x => x.continuousBooking)) {
                this.updateDoors();
            }
        }});
    },
    destroyed() {
        this.unsubscribe?.();
    }
}
</script>
